import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
// Legacy stylesheet (3.9k lines) — provides every class used by the
// chat page so the React port has visual parity without rewriting CSS.
// Sourced from web-ui/public/style.css on the saurav/staging branch.
import './styles/legacy.css';
// KaTeX stylesheet — required for math (\[…\], \(…\)) rendered in chat replies
// (chat/markdown.ts). Vite bundles the referenced web fonts.
import 'katex/dist/katex.min.css';
import './styles.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// PWA: register the service worker so the browser offers "Install app" (the
// in-app button lives in the sidebar). The SW is network-first and non-caching
// for assets, so it's safe alongside the dev server. Failures are non-fatal.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    void navigator.serviceWorker.register('/sw.js').catch(() => { /* PWA install just won't be offered */ });
  });
}
